
const isMobile = screen.width <= 620 ? true : false;

let menuStatus = localStorage.getItem('menu_status');

// Eğer mobil ise sayfa açıldığı zaman menüyü kapat
if (isMobile) {
  localStorage.setItem('menu_status', 'close');

// Eğer masaüstü ise ve menü açıksa sayfa açıldığında menüyü 
} else if (menuStatus == 'open') {
  document.querySelector('html').classList.add('menu-open');
}

// Menu aç kapat
document.querySelectorAll('.toggle-menu-button').forEach( (target) => {
  target.addEventListener('click', (event) => {
    
    event.preventDefault();
    
    menuStatus = localStorage.getItem('menu_status');

    if (menuStatus == 'open') {
      document.querySelector('html').classList.remove('menu-open');
      localStorage.setItem('menu_status', 'close');
    } else {
      document.querySelector('html').classList.add('menu-open')
      localStorage.setItem('menu_status', 'open');
    }
    
  })
})



